import { allegatoShape } from "./allegatoModel";
import { criteriInvioShape } from "./criteriInvioModel";
import { documentoShape } from "./documentoModel";
import { offertaShape } from "./offertaModel";
import { pagamentoShape } from "./pagamentoModel";
import { prodottoRichiestoShape } from "./prodottoRichiestoModel";
import { servizioRichiestoShape } from "./servizioRichiestoModel";
import { trackingStepShape } from "./trackingModel";

export const RichiestaTipo = Object.freeze({
  PRODOTTI: "PRODOTTI",
  SERVIZIO: "SERVIZIO",
});

export const RichiestaStato = Object.freeze({
  BOZZA: "BOZZA",
  INVIATA: "INVIATA",
  SCADUTA: "SCADUTA",
  OFFERTE_RICEVUTE: "OFFERTE_RICEVUTE",
  OFFERTA_ACCETTATA: "OFFERTA_ACCETTATA",
  DA_PAGARE: "DA_PAGARE",
  PAGATA: "PAGATA",
  IN_LAVORAZIONE: "IN_LAVORAZIONE",
  PRONTA: "PRONTA",
  CONSEGNATA: "CONSEGNATA",
  COMPLETATA: "COMPLETATA",
  ANNULLATA: "ANNULLATA",
});

/**
 * Entity Richiesta (utente) coerente con il documento funzionale:
 * - tipo PRODOTTI con carrello multi-item
 * - tipo SERVIZIO con singolo servizio
 * - offerte ordinate/accettate
 * - pagamento e tracking stato
 */
export const richiestaShape = {
  id: "",
  codice: "",
  tipo: RichiestaTipo.PRODOTTI,
  titolo: "",
  stato: RichiestaStato.INVIATA,
  utenteId: "",
  selectedSellerId: null,
  createdAt: "",
  expiresAt: "",
  updatedAt: "",
  unreadOffersCount: 0,
  noteUtente: "",
  criteriInvio: criteriInvioShape,
  prodotti: [prodottoRichiestoShape],
  servizio: servizioRichiestoShape,
  allegati: [allegatoShape],
  offerte: [offertaShape],
  pagamento: pagamentoShape,
  tracking: [{ ...trackingStepShape, stato: RichiestaStato.INVIATA }],
  documenti: [documentoShape],
};

export const createRichiestaModel = (overrides = {}) => ({
  ...richiestaShape,
  ...overrides,
  criteriInvio: overrides.criteriInvio || criteriInvioShape,
  prodotti: Array.isArray(overrides.prodotti) ? overrides.prodotti : [],
  servizio:
    overrides.servizio === null || overrides.servizio === undefined
      ? overrides.servizio ?? null
      : overrides.servizio,
  allegati: Array.isArray(overrides.allegati) ? overrides.allegati : [],
  offerte: Array.isArray(overrides.offerte) ? overrides.offerte : [],
  pagamento: overrides.pagamento || pagamentoShape,
  tracking: Array.isArray(overrides.tracking) ? overrides.tracking : [],
  documenti: Array.isArray(overrides.documenti) ? overrides.documenti : [],
});



